<script>
import AdminFilter from "@/components/Admin/Report/Filter"
import AdminList from "@/components/Admin/Report/List"
export default {
    name:"AdminReport",
    data: () => ({
    }),
    components:{
        AdminFilter,
        AdminList
    }
}
</script>
<template>
    <div id="AdminReport">
        <AdminFilter />
        <AdminList />
    </div>
</template>